export const KBAR_SECTION = {
  PREFERENCES: 'preferences',
  SHORTCUTS: 'shortcuts',
  APPS_ACTION: 'action',
  FAV_APP: 'favorite apps',
  NAVIGATION: 'navigation',
};
